import { render, staticRenderFns } from "./indexPC.vue?vue&type=template&id=42c774c4&scoped=true"
import script from "./indexPC.vue?vue&type=script&lang=js"
export * from "./indexPC.vue?vue&type=script&lang=js"
import style0 from "./indexPC.vue?vue&type=style&index=0&id=42c774c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c774c4",
  null
  
)

export default component.exports